import React, { useState, useEffect } from 'react';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import { TModal } from './types.d';

export const TransitionsModal: React.FC<TModal> = ({
  state = false,
  title = '',
  children,
  width,
  height,
  overflow,
  handleCloseModal,
  disabledClose = true,
}) => {
  const [open, setOpen] = useState(state);

  // const hide = useCallback(() => {
  //   setOpen(false);
  //   handleCloseModal(false);
  // }, [handleCloseModal]);

  useEffect(() => {
    setOpen(state);
  }, [state]);

  const style = {
    modal: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      display: 'flex',
      flexDirection: 'column',
      transform: 'translate(-50%, -50%)',
      width: width || 400,
      maxWidth: '95vw',
      height: height || 400,
      maxHeight: '95vh',
      bgcolor: 'background.paper',
      borderRadius: '5px',
      p: 3,
      border: 'none',
      outline: 'none',
      boxSizing: 'border-box',
      overflow: 'hidden',
    },
  };
  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        sx={{ wordWrap: 'break-word', height: 'auto' }}
        open={open}
        // onClose={hide}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}>
        <Fade in={open}>
          <Box sx={style.modal}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                height: '100%',
                overflow: 'hidden',
              }}>
              {disabledClose ? (
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', flexShrink: 0 }}>
                  <CloseIcon
                    onClick={() => {
                      setOpen(false);
                      handleCloseModal(false);
                    }}
                    sx={{ cursor: 'pointer' }}
                  />
                </Box>
              ) : null}
              {title ? (
                <Typography id="transition-modal-title" variant="h6" component="h2">
                  {title}
                </Typography>
              ) : null}
              <Box sx={{ overflow: overflow || 'auto', flex: 1, width: '100%', minHeight: 0 }}>
                {children}
              </Box>
            </Box>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
};
